import { concatAll } from '../operators/concatAll';
import { isScheduler } from '../util/isScheduler';
import { fromArray } from './fromArray';
export function concat(...args) {
    let scheduler;
    if (isScheduler(args[args.length - 1])) {
        scheduler = args.pop();
    }
    return concatAll()(fromArray(args, scheduler));
}
//# sourceMappingURL=concat.js.map